'use client';

import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import type { Route } from 'next';
import { useRouter } from 'next/navigation';
import ReactPaginate from 'react-paginate';
import type { VariantType } from '../../../types/variant';
import FaIcon from '../../icon/FaIcon/FaIcon';
import styles from './Pagination.module.scss';
import raffleStyles from './Pagination.raffle.module.scss';

export type PaginationProps = {
  currentPage: number;
  total: number;
  perPage: number;
  lastPage: number;
  queryString?: string;
  variant?: VariantType;
};

function Pagination({ currentPage, total, perPage, queryString = 'page', variant = 'default' }: PaginationProps) {
  const router = useRouter();
  const currentStyles = variant === 'raffle' ? raffleStyles : styles;

  const changePage = (selectedItem: { selected: number }) => {
    // URLを書き換える
    const params = new URLSearchParams(location.search);
    params.set(queryString, String(selectedItem.selected + 1));
    router.push(`${location.pathname}?${params.toString()}` as Route);
  };

  const totalPageCount = Math.ceil(total / perPage);

  return (
    <>
      {totalPageCount > 0 && (
        <ReactPaginate
          breakLabel={'...'}
          nextLabel={<FaIcon icon={faChevronRight} />}
          previousLabel={<FaIcon icon={faChevronLeft} />}
          onPageChange={changePage}
          pageRangeDisplayed={3}
          marginPagesDisplayed={1}
          pageCount={totalPageCount}
          initialPage={currentPage - 1}
          disableInitialCallback={true}
          className={currentStyles.pagination}
          pageClassName={currentStyles.pageItem}
          pageLinkClassName={currentStyles.pagelink}
          activeLinkClassName={currentStyles.currentLink}
          breakClassName={currentStyles.lastOmit}
          previousClassName={currentStyles.pagePrev}
          nextClassName={currentStyles.pageNext}
        />
      )}
    </>
  );
}

export default Pagination;
